// 3rd party
import React, { ReactElement, useEffect, useState } from 'react';
import styled from 'styled-components';
import 'react-toastify/dist/ReactToastify.css';
import Icon from '../../img/cart.svg';

// Components
import { Badge, CartWizard, Modal } from 'components';

// Types
import { CartState } from 'types/parts/cart';

// Custom hooks
import { useAuthToken, useCart } from 'selectors';

// Analytics
import { generateAnalyticsEvent } from 'common/helpers/v1/analytics';
import { AnalyticsCategories, ECommerceAnalyticEventActions } from 'constants/analytics';
import ShoppingCart from 'icons/indexed-icons/ShoppingCart';
import theme from 'themes';
import { useGetRemoteCartItemsQuery } from 'api'
import { cartActions } from 'actions';
import { useDispatch } from 'react-redux';

const ImageCart = styled.div`
  cursor: pointer;
  font-size: 15px;
  color: ${(props) => props.theme.colors.darkGrey};
  position: relative;
  padding-top: 4px;

  .icon path {
    stroke-width: 1.75;
  }
`;

const ContextAwareCart = (): ReactElement => {
  const authToken = useAuthToken();
  const cart = useCart() as CartState | undefined;
  const [showModal, setShowModal] = useState<boolean>(false);
  const [itemsInCart, setItemsInCart] = useState<number>(0);
  const {data: cartItems, refetch: refetchRemoteCart} = useGetRemoteCartItemsQuery();
  const dispatch = useDispatch();

  useEffect(() => {
    if (authToken) {
      refetchRemoteCart(); // Refetch cart items when authToken changes (e.g., on login)
    }
  }, [authToken]);


  useEffect(() => {
    if(cart && cart.items.length > 0){
       setItemsInCart(cart.items.map((item) => item.quantity).reduce((prev, current) => prev + current, 0));
    } else {
      setItemsInCart(-1);
    }
  }, [cart]);
  useEffect(()=> {
      if(cartItems && cartItems.length > 0){
      // Dispatch backend cart items to the redux store
      cartItems.forEach((item) => {
        for (let i = 0; i < item.quantity; i++) {
           dispatch({
          type: cartActions.ADD_TO_CART,
          item: item,
          quantity: 1,
          groupId: item.groupId,
          groupDescription: item.groupDescription,
          hideToast: true
        });
        }
       
      });
    }
  }, [cartItems]);
    
 
  return (
    <>
      <div>
        <ImageCart
          data-testid="cart-icon"
          onClick={() => {
            setShowModal(true);
            generateAnalyticsEvent({
              category: AnalyticsCategories.ECOMMERCE,
              action: ECommerceAnalyticEventActions.BEGIN_CHECKOUT,
              event: ECommerceAnalyticEventActions.BEGIN_CHECKOUT
            });
          }}
        >
          <ShoppingCart color={theme.colors.lightGrey10} />
          {itemsInCart && itemsInCart > 0 && (
            <Badge key={itemsInCart} style={{ top: 1 }}>
              {itemsInCart}
            </Badge>
          )}
        </ImageCart>
      </div>

      <Modal visible={showModal} onClose={() => setShowModal(false)}>
        <CartWizard active={showModal} handleClose={() => setShowModal(false)} />
      </Modal>
    </>
  );
};

export default ContextAwareCart;
